export default {"src":"/_next/static/media/open-box.ca1aadaf.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};